import React from 'react';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DescriptionIcon from '@mui/icons-material/Description';
import TableChartIcon from '@mui/icons-material/TableChart';
import ImageIcon from '@mui/icons-material/Image';
import ArticleIcon from '@mui/icons-material/Article';
import FolderZipIcon from '@mui/icons-material/FolderZip';
import SlideshowIcon from '@mui/icons-material/Slideshow';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import CodeIcon from '@mui/icons-material/Code';

const FILE_TYPE_CONFIG = {
  'application/pdf': { icon: PictureAsPdfIcon, color: '#f44336' },
  'application/msword': { icon: DescriptionIcon, color: '#1565c0' },
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': { icon: DescriptionIcon, color: '#1565c0' },
  'application/vnd.ms-excel': { icon: TableChartIcon, color: '#2e7d32' },
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': { icon: TableChartIcon, color: '#2e7d32' },
  'application/vnd.ms-powerpoint': { icon: SlideshowIcon, color: '#e65100' },
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': { icon: SlideshowIcon, color: '#e65100' },
  'text/plain': { icon: ArticleIcon, color: '#757575' },
  'text/csv': { icon: TableChartIcon, color: '#388e3c' },
  'application/zip': { icon: FolderZipIcon, color: '#f57c00' },
  'application/x-zip-compressed': { icon: FolderZipIcon, color: '#f57c00' },
  'application/json': { icon: CodeIcon, color: '#7b1fa2' },
  'text/html': { icon: CodeIcon, color: '#7b1fa2' },
};

const IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml', 'image/bmp'];

const FileTypeIcon = ({ mimeType, sx = {}, fontSize = 'medium' }) => {
  if (IMAGE_TYPES.includes(mimeType)) {
    return <ImageIcon sx={{ color: '#9c27b0', ...sx }} fontSize={fontSize} />;
  }
  const config = FILE_TYPE_CONFIG[mimeType];
  if (config) {
    const Icon = config.icon;
    return <Icon sx={{ color: config.color, ...sx }} fontSize={fontSize} />;
  }
  return <InsertDriveFileIcon sx={{ color: '#9e9e9e', ...sx }} fontSize={fontSize} />;
};

export default FileTypeIcon;
